
<div class="container-fluid mt-3">
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Education Meeting':'Add Education Meeting' }}</h2>
  <form [formGroup]="momForm" class="row" autocomplete="off">
    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="allCenters$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>

    <!-- Session Date -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
      <mat-label>Select Meeting Type</mat-label>
      <mat-select formControlName="place">
        <mat-option *ngFor="let t of type" [value]="t">
          {{ t }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Type</mat-label>
      <mat-select formControlName="type" (selectionChange)="onTypeChange($event)">
        <mat-option *ngFor="let t of typeOfMeeting$ |async" [value]="t">
          {{ t }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Updated Participants Field with Multi-Select -->
    <div class="col-md-8 d-flex align-items-start gap-2">
      <mat-form-field appearance="outline" class="flex-grow-1">
        <mat-label>Select Participants</mat-label>
        <mat-select
          #select
          multiple
          formControlName="participants"
          [compareWith]="compareParticipants"
          (openedChange)="onParticipantDropdownOpened($event)"
          aria-label="Select Participants"
          #participantSelect="matSelect">

          <!-- Trigger display -->
          <mat-select-trigger>
      <span *ngIf="participantSelect.value?.length; else noParticipantSelection">
        {{ participantSelect.value[0]?.name | slice:0:16 }}
        {{ participantSelect.value[0]?.name?.length > 16 ? '...' : '' }}
        <span *ngIf="participantSelect.value.length > 1" class="textcol">
          (+{{ participantSelect.value.length - 1 }} more)
        </span>
      </span>
            <ng-template #noParticipantSelection>
              Select Participants...
            </ng-template>
          </mat-select-trigger>

          <!-- Search box -->
          <div class="mat-select-search" style="padding: 8px;">
            <input
              type="text"
              placeholder="Search participant..."
              [(ngModel)]="participantSearch"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="filterParticipants()"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              class="employee-search-input w-100 p-0 border rounded"
              autocomplete="off"
            />
          </div>

          <!-- Participant options -->
          <app-select-all [matSelect]="select"></app-select-all>

          <mat-option *ngFor="let teacher of filteredTeachers" [value]="teacher">
            {{ teacher.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="momForm.get('participants')?.hasError('required')">
          Participants are required
        </mat-error>
      </mat-form-field>

      <!-- Add Participants Button -->
      <button
        mat-mini-fab
        color="accent"
        type="button"
        (click)="openParticipantsDialog()"
        matTooltip="Add participants from all employees"
        matTooltipPosition="above"
        style="margin-top: 8px;">
        <mat-icon>group_add</mat-icon>
      </button>
    </div>

    <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
      <mat-label>Descriptions</mat-label>
      <textarea
        matInput
        formControlName="content"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"
      ></textarea>
      <mat-error
        *ngIf=" momForm.controls.unitCode?.invalid  &&  (momForm.controls.content?.touched || momForm.controls.subject?.dirty)">
        <mat-error style="color: red;" *ngIf="momForm.controls.content?.errors?.required">*It is
          Required.
        </mat-error>
        <mat-error style="color: red;" *ngIf="momForm.controls.content?.errors?.pattern">*Enter
          Only characters.
        </mat-error>
      </mat-error>
    </mat-form-field>

    <div class="col-md-12 mb-3">
      <label class="fw-bold">Suggestions / Remarks</label>
      <ckeditor
        [editor]="Editor"
        [config]="editorConfig"
        formControlName="suggestions"
        (ready)="onEditorReady($event)"
        style="height: 251px;"
      ></ckeditor>
    </div>

    <!-- Submit Button -->
    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="momForm.invalid || isLoading" (click)="submitForm()">
        {{ currentEditId ? 'Update ':'Submit' }}
      </button>
    </div>
  </form>
</div>

<!-- Loader Spinner -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
